import { connect } from 'react-redux';

const mapStateToProps = ({
   appData: {
      userData: { status },
   },
}) => ({
   authStatus: status,
});

const AuthConditionalRender = connect(mapStateToProps)(
   ({ children, authStatus, allowedStatuses, deniedStatuses }) => {
      if (
         (allowedStatuses && allowedStatuses.includes(authStatus)) ||
         (deniedStatuses && !deniedStatuses.includes(authStatus))
      ) {
         return children;
      }

      return null;
   }
);

export { AuthConditionalRender };
